<template>
  <div>
    <div v-if="item">
      <h3 class="title is-3">
        <router-link to="/pages">
          <b-icon icon="chevron-left" size="is-small"></b-icon>
        </router-link>
        &nbsp;
        {{item.name}}
      </h3>
      <a :href="item.url" target="blank">{{item.url}}</a>
      <hr>
      <div class="columns" v-if="editablePage">
        <div class="column">
          <!-- name -->
          <div class="field">
            <label class="label">Name</label>
            <div class="control">
              <input class="input" type="text" v-model="editablePage.name">
            </div>
          </div>
          <!-- description -->
          <div class="field">
            <label class="label">Description</label>
            <div class="control">
              <input class="input" type="text" v-model="editablePage.description">
            </div>
          </div>
          <!-- url -->
          <div class="field">
            <label class="label">Url</label>
            <div class="control">
              <input class="input" type="text" v-model="editablePage.url">
            </div>
          </div>
        </div>
        <div class="column">
          <!-- enabled -->
          <div class="field">
            <label class="label">Enabled</label>
            <b-switch v-model="editablePage.enabled" type="is-success"></b-switch>
          </div>
          <!-- visible -->
          <div class="field">
            <label class="label">Visible</label>
            <b-switch v-model="editablePage.visible" type="is-success"></b-switch>
          </div>
          <!-- root -->
          <div class="field">
            <label class="label">Show on Root</label>
            <b-switch v-model="editablePage.root" type="is-success"></b-switch>
          </div>
        </div>
      </div>
      <div class="field">
          <button class="button is-primary" @click="update">Save</button>
      </div>
    </div>
    <loading v-else></loading>
  </div>
</template>

<script>
import loading from "@/components/Loading";
import { GET_PAGE, UPDATE_PAGE } from "@/store/actions";

export default {
  name: "Page",
  components: { loading },
  data() {
    return {
      editablePage: null
    };
  },
  computed: {
    item() {
      return this.$store.state.pages.page;
    }
  },
  mounted() {
    const { id } = this.$route.params;
    if (!this.item || this.item._id !== id) {
      this.$store.dispatch(GET_PAGE, id).then(res => {
        if (res && res.data) {
          this.editablePage = this.editableFeed = { ...res.data };
        }
      });
    } else {
      this.editablePage = this.editableFeed = { ...this.item };
    }
  },
  methods: {
      update(){
          this.$store.dispatch(UPDATE_PAGE, this.editablePage).then(res => {
              if(res && res.status === 204){
                  this.$success('Page updated');
              }
          });
      }
  }
};
</script>

